import React, { useEffect, useState } from "react";
import './ViewProjectInduction.css';
import ViewInductionTable from "./ViewInductionTable/ViewInductionTable";
import { useNavigate, useParams } from "react-router-dom";
import ProjectAPIs from "../../../../../../MasonyFixingsAPIs/ProjectAPIs/ProjectAPIs";
import { FaChevronUp, FaChevronDown, FaSave } from "react-icons/fa";
import { MdCancel, MdEdit } from "react-icons/md";
import { AiFillEdit } from "react-icons/ai";
import { Form } from "react-bootstrap";
import { useToast } from "../../../../../../Contexts/ToastContext";

export default function ViewProjectInduction(){

    const { addToast } = useToast();
    const params = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [editing, setEditing] = useState(false);
    const [sending, setSending] = useState(false);
    const [showInductions, setShowInductions] = useState(false);

    const [inductionData, setInductionData] = useState();
    const [indRequired, setIndRequired] = useState();
    const [providedOn, setProvidedOn] = useState();

    const getInductionData = (projectID) => {

        ProjectAPIs.GetProjectInduction(projectID)
        .then((response) => {
            if(response.status === 200){
                setInductionData(response.data);
                setIndRequired(response.data.induction_required);
                setProvidedOn(response.data.induction_provided ?? '');
                setLoading(false);
            }
        })
        .catch((err) => {
            console.log(err)
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const editInduction = (e) => {

        e.preventDefault();
        e.stopPropagation();

        setSending(true);

        const putJSON = {
            induction_required: indRequired,
            induction_provided: providedOn === '' ? null : providedOn
        }
        ProjectAPIs.PutProjectInduction(params.ProjectID, putJSON)
        .then((response) => {
            if(response.status === 200){
                getInductionData(params.ProjectID);
                setEditing(false);
                setSending(false);
                addToast({ message: "Induction requirements updated successfully!", variant: "success", autoHide: true });
            }
        })
        .catch((err) => {
            console.log(err)
            setSending(false);
            if(err.response.status === 401){
                if(err.response.data.logout){
                    navigate('/login');
                }
                else{
                    window.alert(err.response.data.message)
                }
            }
        })
    }

    const handleCancel = () => {
        setIndRequired(inductionData.induction_required);
        setProvidedOn(inductionData.induction_provided ?? '');
        setEditing(false);
    }

    useEffect(() => {
        getInductionData(params.ProjectID);
    }, [params.ProjectID]);


    if(loading){
        return(<div>Loading Inductions...</div>);
    }
    else{
        return(
            <div className="project-section">

               
                <Form onSubmit={editInduction}>
                    <div className="project-section-header">
                        {/* <h5 className="section-title">Induction</h5> */}
                        <div className="project-header-actions">
                            <button
                                disabled={sending || !editing}
                                type="submit"
                                className="save-btn"
                                style={editing ? {display: 'block'} : {display: 'none'}}
                            >
                                {sending ? 'Saving...' : 'Save'}
                            </button>

                            {editing ? (
                                <button
                                    disabled={sending}
                                    type="button"
                                    className="cancel-btn"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </button>
                            ) : (
                                <button
                                    disabled={sending}
                                    type="button"
                                    className="edit-btn"
                                    onClick={() => setEditing(true)}
                                >
                                    <MdEdit /> Edit
                                </button>
                            )}
                        </div>
                    </div>
                
                <div className="project-section-body">


                    {editing ? (
                            <span 
                                className={`status-badge editable ${indRequired ? 'complete' : 'active'}`}
                                onClick={() => setIndRequired(!indRequired)}
                            >
                                {indRequired ? "Required ✓" : "Mark Required"}
                            </span>
                        ) : (
                            <span className={`status-badge ${inductionData.induction_required ? 'complete' : 'active'}`}>
                                {inductionData.induction_required ? "Required" : "Not Required"}
                            </span>
                        )}

                        {editing ? 
                                <div className="project-section-body-item">
                                    <span className="label">Provided On:</span>
                                    <Form.Control
                                        disabled={!editing}
                                        value={providedOn}
                                        onChange={(e) => setProvidedOn(e.target.value)}
                                        className="editable-field"
                                    />
                                </div>
                            :
                            <div className="project-section-body-item">
                                    <span className="label">Provided On:</span>
                                    <span>{inductionData.induction_provided}</span>
                            </div>
                    
                        }

                        
                </div>
                    
                </Form>

                <div className="mt-2">
                    <ViewInductionTable projectID={params.ProjectID} />
                </div>
    
                
                    
                
            </div>
        )
    }
    
}